import * as React from "react"
import {Form} from "semantic-ui-react"
import {Place as PlaceType} from "../model/places/PlaceTypes"
import {ID} from "../model/id"
import {PlaceSuggest} from "./PlaceSuggest"
import {CommonPlacesLocale} from "./CommonPlacesLocale"
import {Locale} from "../model/BookingTypes"

interface Props {
  onPlaceId: (placeId: ID) => void
  onLocale: (locale: Locale) => void
  locale: Locale
}

export class CommonPlaceSearch extends React.Component<Props> {
  handlePlaceSelect = (suggestion: PlaceType) => this.props.onPlaceId(suggestion.id)

  render() {
    const {locale, onLocale} = this.props

    return (
      <div>
        <CommonPlacesLocale localeId={locale.id} onLocale={onLocale} />
        <Form.Field>
          <label>Place</label>
          <PlaceSuggest
            disabled={false}
            placeholder={"Search"}
            onSelect={this.handlePlaceSelect}
            locale={locale}
            raw={true}
          />
        </Form.Field>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CommonPlaceSearch.tsx